import React, { forwardRef } from 'react';

import styles from './ProgressBar.module.css';

export interface ProgressBarProps {
    progress?: number;
    showLabel?: boolean;
    size?: 'small' | 'medium' | 'large';
    color?: 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'error';
    animated?: boolean;
    className?: string;
}

const ProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>(({
    progress = 0,
    showLabel = true,
    size = 'medium',
    color = 'primary',
    animated = false,
    className = ''
}, ref) => {
    // Ensure progress is between 0 and 100
    const normalizedProgress = Math.min(Math.max(progress, 0), 100);

    const progressBarClasses = [
        styles.progressBar,
        styles[size],
        className
    ].filter(Boolean).join(' ');

    const fillClasses = [
        styles.fill,
        styles[color],
        animated && styles.animated
    ].filter(Boolean).join(' ');

    return (
        <div className={progressBarClasses} ref={ref}>
            <div className={styles.track}>
                <div
                    className={fillClasses}
                    style={{ width: `${normalizedProgress}%` }}
                    role="progressbar"
                    aria-valuenow={normalizedProgress}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    {showLabel && (
                        <span className={styles.label}>{normalizedProgress}%</span>
                    )}
                </div>
            </div>
        </div>
    );
});

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
